import React from "react";
import { calculateAge } from "../utils/commonFunctions";
import CasteIcon from "../assests/images/caste-icon.png";
import LangIcon from "../assests/images/lang-icon.png";
import FromLocationIcon from "../assests/images/from-location.png";
import CitizenshipIcon from "../assests/images/CitizenshipIcon.png";
import EthencityIcon from "../assests/images/EthencityIcon.png";
import ResidanceIcon from "../assests/images/ResidanceIcon.png";
import PostalCodeIcon from "../assests/images/PostalCodeIcon.png";

import MarryIcon from "../assests/images/marry-icon.png";
import FamilyDetails from "./FamilyDetails";
import EducationAndCareer from "./EducationAndCareer";
import IntroductionVideo from "./IntroductionVideo";
import { useMasterData } from "../context/MasterDataContext";

const ProfileDetailsView = ({
  UserData,
  client,
  navigate,
  AccesRequestStatus,
  CheckAccesRequestStatus,
  approveTheRequest,
  handleCopy,
  openModal,
  sendAccessRequest,
  isAgentLogin,
  UserId,
  relationList,
  qualifications,
  selectedQualification,
  habitList,
  hobbiesList,
  casteName,
  languages,
  getReligionNameById,
  getCityName,
  getMaritalStatusNameById,
  getBuildNameById,
  getSkinToNameById,
  showBack = false,
  onBack,
}) => {
  const { countryMasterData, allCountyMasterData, communityMasterData } =
    useMasterData();

  console.log(UserData);
  console.log(AccesRequestStatus);
  if (!UserData) return null;
  const downloadDoc = () => {
    const docUrl = UserData?.User?.WedLukDocs?.[0]?.ProfileDocs;

    if (!docUrl) return;

    window.open(docUrl, "_blank");
    // const link = document.createElement("a");
    // link.href = docUrl;
    // link.download = ""; // forces browser download
    // document.body.appendChild(link);
    // link.click();
    // document.body.removeChild(link);
  };

  const getCitizenShipRecidenceName = (id) => {
    const name =
      countryMasterData.find((item) => item.id === id)?.CountryName || "";

    return name;
  };

  const getContryName = (id) => {
    const name =
      allCountyMasterData.find((item) => item.isoCode === id)?.name || "";

    return name;
  };
  const getEthinicityName = (id) => {
    const name =
      communityMasterData.find((item) => item.CommunitiesId === id)
        ?.CommunitiesName || "";

    return name;
  };

  return (
    <div className={showBack ? " " : "main-content"}>
      <div className="d-flex justify-content-between align-items-start p-3 bg-white">
        <div>
          {showBack && (
            <div
              className="mb-2 text-primary"
              style={{ cursor: "pointer" }}
              onClick={onBack}
            >
              ← Back
            </div>
          )}
          <h5 className="fw-bold mb-2">
            {UserData?.User?.FirstName} {UserData?.User?.LastName} ,{" "}
            {calculateAge(UserData?.User?.DOB) && (
              <span className="fw-normal">
                {" "}
                {calculateAge(UserData?.User?.DOB)} Yrs{" "}
                {/* {UserData?.User?.Gender === 1 ? "Male" : "Female"} */}
              </span>
            )}
            <span
              className="click-effect"
              style={{ cursor: "pointer" }}
              onClick={() =>
                navigate("/EditClientProfile", {
                  state: { client: UserData },
                })
              }
            >
              {UserData.ProfileId === client.ProfileId && !showBack && (
                <img
                  height={30}
                  width={30}
                  src={require("../assests/images/notes-icon.png")}
                  alt=""
                />
              )}
            </span>
          </h5>
          <div className="d-flex gap-3">
            {UserData.ProfileId !== client.ProfileId &&
              CheckAccesRequestStatus?.IsAccepted === 1 && (
                <div className="d-flex gap-4" onClick={approveTheRequest}>
                  <button className="accept-btn">
                    {" "}
                    Accept Photo visbile Request ✓{" "}
                  </button>
                </div>
              )}
            {UserData.ProfileId === client.ProfileId && !showBack && (
              <div className="client-code">
                <span> {isAgentLogin ? "Client code:" : "Ref Code:"} </span>
                <span className="code"># {UserData.ClientCode}</span>
                <img
                  src={require("../assests/images/copy-icon.png")}
                  alt="Copy"
                  className="copy-icon"
                  onClick={handleCopy}
                />
              </div>
            )}
            {UserData.ProfileId === client.ProfileId && !showBack && (
              <div className="client-code">
                <span>Contact Number: </span>
                <span className="code">
                  {(() => {
                    const countryCode = UserData?.User?.CountyCode || "";
                    const phone = UserData?.User?.PhoneNumber || "";

                    const numericPhone = phone.replace(/\D/g, "");

                    return !isAgentLogin || client.UserId === UserId
                      ? `+${countryCode} ${numericPhone}`.trim()
                      : `+${countryCode} ${numericPhone}`.trim();
                  })()}
                </span>
              </div>
            )}
          </div>
        </div>

        <div class="agent-card-new">
          <div class="agent-name">
            {" "}
            {UserData?.BusinessDetails?.BusinessName
              ? "Agent"
              : "Client"} :{" "}
            {UserData?.BusinessDetails?.BusinessName ||
              UserData?.BusinessDetails?.FirstName ||
              ""}{" "}
          </div>
          <div className="agent-contact">
            {UserData?.BusinessDetails?.BusinessName ? "Agent" : "Client"}{" "}
            {UserData?.BusinessDetails?.AgentContactNumber ||
            UserData?.BusinessDetails?.PhoneNumber
              ? "contact :"
              : "Email:"}{" "}
            <span className="phone-number">
              {(UserData?.BusinessDetails?.PhoneNumber ||
                UserData?.BusinessDetails?.AgentContactNumber) &&
                UserData?.BusinessDetails?.CountyCode}{" "}
              {UserData?.BusinessDetails?.AgentContactNumber ||
                UserData?.BusinessDetails?.PhoneNumber ||
                UserData?.BusinessDetails?.EMail}
            </span>
          </div>
        </div>
      </div>

      <div className="">
        <div className="img-con">
          {(UserData?.User?.WedLukDocs?.[0]?.ProfileImages || [])
            .slice()
            .reverse()
            .map((img, index) => (
              <div className="" key={index}>
                <div className="position-relative">
                  <img
                    src={img} // Replace with your actual image path
                    alt={`Image ${index}`}
                    className={`profile-imgages   ${
                      UserData.ProfileId !== client.ProfileId &&
                      AccesRequestStatus !== 2 &&
                      !UserData.IsPhotoVisible &&
                      (isAgentLogin
                        ? UserData?.AgentId !== client?.AgentId
                        : true)
                        ? "blurred-img"
                        : ""
                    }`}
                    onClick={() => {
                      if (UserData.ProfileId === client.ProfileId) {
                        openModal(img);
                        return;
                      }
                      if (AccesRequestStatus === 2) {
                        openModal(img);
                      }
                    }}
                    style={{ cursor: "pointer" }}
                  />
                  {index === 0 &&
                    AccesRequestStatus !== 2 &&
                    UserData.ProfileId !== client.ProfileId &&
                    (isAgentLogin
                      ? UserData?.AgentId !== client?.AgentId
                      : true) &&
                    !UserData.IsPhotoVisible && (
                      <div
                        className="overlay d-flex justify-content-center align-items-center"
                        onClick={sendAccessRequest}
                      >
                        {AccesRequestStatus !== 1 ? (
                          <span className="btn btn-dark btn-sm">
                            Request photo access
                          </span>
                        ) : (
                          <span className="btn btn-dark btn-sm">
                            Request Sent
                          </span>
                        )}
                      </div>
                    )}
                </div>
              </div>
            ))}
        </div>
      </div>

      <div className="match-details-container-profile p-2">
        {/* Left side: Matched On */}
        <div className="matched-on-profile">
          <div className="matched-label-profile">Matched on:</div>
          <div className="matched-tags-profile">
            <span>Caste</span>
            <div className="divider" />
            <span>Appearance</span>
            <div className="divider" />
            <span>Salary req</span>
            <div className="divider" />
            <span className="more-profile">3 more +</span>
          </div>
        </div>

        {/* Right side: Network Connections */}
        <div className="network-box-profile">
          <div className="network-header-profile">
            Network Connections <span className="gem-icon-profile">💎</span>
          </div>
          <div className="network-body-profile">
            <div className="avatars-profile">
              <img
                src="https://randomuser.me/api/portraits/women/65.jpg"
                alt="Connection 1"
              />
              <img
                src="https://randomuser.me/api/portraits/men/45.jpg"
                alt="Connection 2"
              />
            </div>
            <span className="connection-text-profile">
              5+ connections identified
            </span>
          </div>
        </div>
      </div>

      <div className="row g-4 fs-6 p-1">
        {/* Background Section */}
        <div className="col-md-6">
          <div className="p-3 bg-white rounded shadow-sm border">
            <h6 className="text-color mb-3">Background</h6>

            <div className="row">
              {/* Left Column */}
              <div className="col-6">
                <div className="d-flex align-items-center mb-4">
                  <img src={CasteIcon} alt="" className="icons-for-bg" />
                  <div>
                    <strong className="title-for-bg">
                      {getReligionNameById(UserData?.ReligionId)}
                    </strong>
                    <br />

                    <small> {casteName}</small>
                  </div>
                </div>
                <div className="d-flex align-items-center mb-4">
                  <img src={MarryIcon} alt="" className="icons-for-bg" />
                  <div>
                    <strong className="title-for-bg">
                      {getMaritalStatusNameById(UserData?.MarriageStatusId)}
                    </strong>
                  </div>
                </div>
                <div className="d-flex align-items-center mb-4">
                  <img src={CitizenshipIcon} alt="" className="icons-for-bg" />
                  <div className="d-flex flex-column ">
                    <strong className="title-for-bg">Citizenship</strong>

                    
                     <small>  {getCitizenShipRecidenceName(
                        UserData?.User?.Address?.CitizenshipId,
                      )}</small>
                  </div>
                </div>

                <div className="d-flex align-items-center mb-4">
                  <img src={FromLocationIcon} alt="" className="icons-for-bg" />
                  <div>
                    <div>
                      <strong className="title-for-bg">
                        {getContryName(UserData?.User?.Address?.CountryId)},{" "}
                        {getCityName(UserData?.User?.Address?.CityId)}
                      </strong>
                    </div>
                  </div>
                </div>

                <div className="d-flex align-items-center mb-4"></div>
              </div>

              {/* Right Column */}
              <div className="col-6">
                <div className="d-flex align-items-center  mb-4">
                  <img src={EthencityIcon} alt="" className="icons-for-bg" />
                    <div className="d-flex flex-column ">
                      <strong   className="title-for-bg mb-1" >Community</strong>
                    <small >
                      {getEthinicityName(UserData?.CommunitiesId)}
                    </small>
                  </div>
                </div>
                <div className="d-flex align-items-center mb-5">
                  <img src={LangIcon} alt="" className="icons-for-bg" />
                  <div>
                    {languages
                      .filter((item) =>
                        UserData?.User?.UserLanguage.includes(item.LangId),
                      )
                      .map((language) => (
                        <strong className="title-for-bg" key={language.LangId}>
                          {language.LangDesc},{" "}
                        </strong>
                      ))}
                  </div>
                </div>

                <div className="d-flex align-items-center  mb-4">
                  <img
                    src={ResidanceIcon}
                    alt="city"
                    className="icons-for-bg"
                  />
                  <div>
                    <div className="d-flex flex-column ">
                      <strong className="title-for-bg mb-1">Residence</strong>
                      <small  >
                        {getCitizenShipRecidenceName(
                          UserData?.User?.Address?.ResidenceId,
                        )}
                      </small>
                    </div>
                  </div>
                </div>
                <div className="d-flex align-items-center  mb-4">
                  <img src={PostalCodeIcon} alt="" className="icons-for-bg" />
                  <div>
                    <strong className="title-for-bg">
                      {UserData?.User?.Address?.PostalCode}
                    </strong>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Physique Section */}
        <div className="col-md-6">
          <div className="p-3 bg-white rounded shadow-sm border mb-4">
            <div className=" ">
              <h6 className="text-color mb-3">Physique</h6>
              <div className="row-line">
                <div className="vertical-divider" />
                <div className="value-text">{UserData?.Height} feet</div>
                <div className="vertical-divider" />
                <div className="value-text">{UserData?.Weight} Kg</div>
              </div>
              <div className="row-line bottom-row">
                <div className="label-group">
                  <div className="label-text">Build</div>
                  <div className="bold-text-for-value">
                    {" "}
                    {getBuildNameById(UserData?.BuildId)}
                  </div>
                </div>
                <div className="label-group">
                  <div className="label-text">Skin tone</div>
                  <div className="bold-text-for-value">
                    {" "}
                    {getSkinToNameById(UserData?.SkinToneId)}
                  </div>
                </div>
              </div>

              {UserData?.User?.WedLukDocs[0]?.ProfileDocs && (
                <div className="doc-card">
                  <span className="doc-name">
                    {" "}
                    {UserData?.User?.WedLukDocs[0]?.ProfileDocsName}
                  </span>

                  <img
                    className="doc-download-btn"
                    src={require("../assests/images/download-icon.png")}
                    onClick={() => downloadDoc()}
                  />
                </div>
              )}
            </div>
          </div>
        </div>

        <FamilyDetails
          familyMembers={UserData?.User.familyDetails}
          relationList={relationList}
          familyWealth={UserData?.User.familyWealth}
        />

        {UserData && (
          <EducationAndCareer
            UserData={UserData}
            selectedQualification={selectedQualification}
            qualifications={qualifications}
          />
        )}

        {UserData && (
          <IntroductionVideo
            habitList={habitList}
            hobbiesList={hobbiesList}
            MainProfile={client}
            UserData={UserData}
            AccesRequestStatus={AccesRequestStatus}
          />
        )}
      </div>
    </div>
  );
};

export default ProfileDetailsView;
